module.exports = __webpack_public_path__ + "img/Icon-01.b9dfef26.svg";